"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFormatterBuilderFactory = void 0;
const event_formatter_builder_1 = require("./event-formatter-builder");
class EventFormatterBuilderFactory {
    constructor(params) {
        this._params = params;
    }
    createEventFormatterBuilder(componentName) {
        return new event_formatter_builder_1.EventFormatterBuilder({ factoryParams: this._params, componentName });
    }
}
exports.EventFormatterBuilderFactory = EventFormatterBuilderFactory;
//# sourceMappingURL=event-formatter-builder-factory.js.map